import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Auto refresh on 401
let refreshing = null;
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry && !original.url.includes("/auth/")) {
      original._retry = true;
      try {
        if (!refreshing) refreshing = api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(original);
      } catch (e) {
        refreshing = null;
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export default api;

export function formatApiErrorDetail(detail) {
  const clean = (s) => String(s).replace(/^Value error,\s*/i, "");
  if (detail == null) return "Algo ha salido mal. Inténtalo de nuevo.";
  if (typeof detail === "string") {
    // respuestas HTML de la pasarela (502/520): no tiene sentido mostrarlas al usuario
    if (/^\s*<|<!doctype/i.test(detail)) return "El servidor tardó demasiado en responder. Inténtalo de nuevo.";
    return clean(detail);
  }
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? clean(e.msg) : JSON.stringify(e)))
      .filter(Boolean)
      .join(" · ");
  if (detail && typeof detail.msg === "string") return clean(detail.msg);
  return String(detail);
}

export function formatMoney(v) {
  if (v == null || isNaN(v)) return "—";
  return new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR", maximumFractionDigits: 0, useGrouping: "always" }).format(v);
}
export function formatMoney2(v) {
  if (v == null || isNaN(v)) return "—";
  return new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR", useGrouping: "always" }).format(v);
}
export function formatNumber(v) {
  if (v == null || isNaN(v)) return "—";
  return new Intl.NumberFormat("es-ES", { useGrouping: "always" }).format(v);
}
export function formatPct(v) {
  if (v == null || isNaN(v)) return "—";
  return new Intl.NumberFormat("es-ES", { style: "percent", minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(v);
}

export const ABCD_ORDER = ["AA", "A", "BB", "B", "CC", "C", "D"];
export const ABCD_LABELS = {
  AA: "DÍA",
  A: "SEMANA",
  BB: "DECENA",
  B: "MES",
  CC: "TRIMESTRE",
  C: "AÑO",
  D: "SIN VENTAS",
};
export const ABCD_COLORS = {
  AA: "#10B981",
  A: "#34D399",
  BB: "#3B82F6",
  B: "#60A5FA",
  CC: "#F59E0B",
  C: "#FBBF24",
  D: "#EF4444",
};
